import { Component, OnInit ,Output,EventEmitter,Input} from '@angular/core';
import { Themes, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { CountryIds } from 'src/app/models/common.enums';
import { DataContextService } from 'src/app/services/datacontext.service';
import { PreferencesCurrentViewService } from 'src/app/services/preferences/preferences-current-view';
import {ButtonKind, ButtonOptions } from '../button/button.component';

@Component({
  selector: 'app-inoffice-virtual-toggle',
  templateUrl: './inoffice-virtual-toggle.component.html',
  styleUrls: ['./inoffice-virtual-toggle.component.less']
})
export class InofficeVirtualToggleComponent implements OnInit {
  @Output() toggleInOffice:EventEmitter<boolean>=new EventEmitter<boolean>();
  @Input() isInOfficeSelected:boolean =  true;
  IsCAMemberFirm:boolean=false;
  buttonOption: ButtonOptions = {
    kind: ButtonKind.primaryLoud,
    icon: 'icon-in-office-24'
  }
  buttonOptionVirtual: ButtonOptions = {
    kind: ButtonKind.primary,
    icon: 'icon-virtual-16'
  }

  constructor(private prefService:PreferencesCurrentViewService, private dataContextService:DataContextService) { 
    //Phase1 - MF related changes for virtual options
    // this.dataContextService.masterDadaLoaded$.subscribe((value)=>{
    //   if(value){
    //     this.prefService.currentView$.subscribe((res)=>{
    //       this.checkCAMemberFirm(res.country)
    //     })
    //   }
    //   })
  }
  //Phase1 - MF related changes for virtual options
//   checkCAMemberFirm(countries) {
//     this.IsCAMemberFirm = false
//     countries.forEach(country => {
//         if (country.value == CountryIds.Canada || country.value == CountryIds.Chile) {
//           this.isInOfficeSelected = true;
//           this.IsCAMemberFirm = true;
//           this.buttonOptionVirtual.kind= ButtonKind.primary;
//           this.buttonOption.kind= ButtonKind.primaryLoud;
//         }
//     })
// }

  ngOnInit(): void {
    this.switchInOffice(this.isInOfficeSelected);
  }

  switchInOffice(flag: boolean) {
    if (this.isInOfficeSelected != flag) {
      this.isInOfficeSelected = flag;
      this.toggleInOffice.emit(flag);
    }
    if(!this.isInOfficeSelected){
      this.buttonOptionVirtual.kind= ButtonKind.primaryLoud
      this.buttonOption.kind= ButtonKind.primary
    }
    else{
      this.buttonOptionVirtual.kind= ButtonKind.primary
      this.buttonOption.kind= ButtonKind.primaryLoud
    }
  }
 
}
